import { Injectable } from '@angular/core';
// import { NuarArchitectureService, NuarStorageService, JSONtoStore } from '../nuar.module';


/**
 * Se encarga de realizar todos los almacenamientos internos de la página asi recuperarlos
 */
@Injectable()
export class StorageService {
  /**
   * Prefijo con el cual se van a almacenar todos los storages
   */
  prefix: string;
  constructor(
    // private _architectureService: NuarArchitectureService
  ) {
    this.prefix = 'particulares';
  }
  /**
   * Cambia el prefijo. Esto replicará para todas sus invocaciones.
   * ESTO SOLO SE DEBERIA REALIZAR EN APPCOMPONENT O APPMODULE. NUNCA DENTRO DE LAS PAGINAS INTERNAS
   * @param prefixRef Prefijo con el cual se van a almacenar todos los storages
   */
  setPrefix(prefixRef: string) {
    this.prefix = prefixRef;
  }

  /**
   * Añade o modifica un valor al locastorage
   * @param key id del valor
   * @param value contenido del valor
   */
  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Recupera un valor del storage, Si este valor no esta definido devolverá null
   * @param key id del contenido a recuperar
   */
  get(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (error) {
      return sessionStorage.getItem(key);
    }
  }

  /**
   * Elimina un contenido del storage
   * @param key id del contenido a eliminar
   */
  remove(key) {
    sessionStorage.removeItem(key);
  }


  removeAll() {
    sessionStorage.clear();
  }
}
